import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import { AuthProvider } from "./accounts/AuthContext";
import ProtectedRoute from "./accounts/ProtectedRoute";

import { HeaderProvider } from "./contexts/HeaderContext";

import LoginPage from "./accounts/Login";
import OAuthCallback from "./accounts/OAuthCallback";
import { ResetPasswordByLink, resetPasswordByLinkLoader } from "./accounts/PasswordResetByLink";
import RequestPasswordReset from "./accounts/RequestPasswordReset";
import SignupPage from "./accounts/Signup";
import VerifyEmailPage from "./accounts/VerifyEmail";

import { AccountLayout } from "./accounts/AccountLayout";
import WorkspaceLayout from "./components/WorkspaceLayout";
import Dashboard from "./dashboard/Dashboard";
import LearningJourneyEnvironment from "./dashboard/LearningJourneyEnvironment.jsx";
import LearningJourneySpace from "./dashboard/LearningJourneySpace.jsx";
import Plan from "./dashboard/Plan.jsx";
import Review from "./dashboard/Review.jsx";

import { ROUTES } from "./routes.js";

export const toRelative = (base, full) =>
    full.startsWith(base)
        ? full.slice(base.length).replace(/^\/+/, "")
        : full;


const WorkspaceApp = () => {
    const router = createBrowserRouter([
        // Protected workspace routes
        {
            path: ROUTES.BOARD,
            element: (
                <ProtectedRoute>
                    <HeaderProvider>
                        <WorkspaceLayout />
                    </HeaderProvider>
                </ProtectedRoute>
            ),
            children: [
                { index: true, element: <Dashboard /> },
                {
                    path: "t/:id",
                    element: <LearningJourneyEnvironment />,
                    children: [
                        { index: true, element: <LearningJourneySpace /> },
                        { path: "plan", element: <Plan /> },
                        { path: "step/:stepId", element: <Review /> },
                    ],
                },
                { path: "*", element: <Dashboard /> },
            ],
        },

        // Public / account routes
        {
            path: ROUTES.ACCOUNT.BASE,
            element: <AccountLayout />,
            children: [
                { path: toRelative(ROUTES.ACCOUNT.BASE, ROUTES.ACCOUNT.SIGNUP), element: <SignupPage /> },
                { path: toRelative(ROUTES.ACCOUNT.BASE, ROUTES.ACCOUNT.LOGIN), element: <LoginPage /> },
                { path: toRelative(ROUTES.ACCOUNT.BASE, ROUTES.ACCOUNT.VERIFY_EMAIL), element: <VerifyEmailPage /> },

                {
                    path: toRelative(ROUTES.ACCOUNT.BASE, ROUTES.ACCOUNT.PASSWORD_RESET),
                    loader: resetPasswordByLinkLoader,
                    element: <RequestPasswordReset />,
                },
                {
                    path: toRelative(ROUTES.ACCOUNT.BASE, ROUTES.ACCOUNT.PASSWORD_RESET_KEY),
                    loader: resetPasswordByLinkLoader,
                    element: <ResetPasswordByLink />,
                },

                {
                    path: toRelative(ROUTES.ACCOUNT.BASE, ROUTES.ACCOUNT.PROVIDER_CALLBACK),
                    element: <OAuthCallback />
                }
            ],
        },
        {
            path: "*",
            element: <Navigate to={ROUTES.ROOT} replace />
        }
    ]);

    return (
        <AuthProvider>
            <RouterProvider router={router} />
        </AuthProvider>
    );
};

export default WorkspaceApp;
